import * as SFDCActions from 'app/modules/sfdc/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchSFDCMetricsMappings } from 'app/modules/sfdc/actions'
import { getSFDCMetricMappings, getSFDCPatchMetricsLoading, getSFDCPatchMetricsErr } from 'app/modules/sfdc/selectors'

import SalesforceMetricsMapping from '../MetricsMapping'

function mapStateToProps(state) {
  return {
    sfdcMetricMappings: getSFDCMetricMappings(state),
    sfdcPatchMetricsLoading: getSFDCPatchMetricsLoading(state),
    sfdcPatchMetricsErr: getSFDCPatchMetricsErr(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...SFDCActions, fetchSFDCMetricsMappings }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceMetricsMapping)



// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/containers/MetricsMapping.js